import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';

import { getAllVehiclesAsRack } from '../../features/assets/assetsSlice';
import { lockUnlock } from '../../features/assets/assetsApi';


const LockUnlockModal = ({ assetId, cmdName, usercmd, lockInput, lockModalOpen, handleLockModalClose }) => {

    const dispatch = useDispatch();

    const rack = useSelector(getAllVehiclesAsRack);
    const assetData = rack[`${assetId}`];
    const regn = assetData && assetData.vehicleDevice.regn;
    const speed = assetData && assetData.coreData && assetData.coreData.speed;
    const summaryStatus = assetData && assetData.statusMeta && assetData.statusMeta.summaryStatus;

    const [lockpassword, setLockpassword] = useState("");
    const [userphone, setUserphone] = useState("");

    const lockValidate = () => {
        if (summaryStatus === 'Malfunction') {
            return false;
        } else if (usercmd === 'lock') {
            if (speed > 20) {
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    const formDisable = () => {
        let disabled = false;
        if (!lockValidate()) {
            disabled = true;
        }
        if (!userphone) {
            disabled = true;
        }
        else if (userphone.length !== 10) {
            disabled = true;
        }
        if (!assetId) {
            disabled = true;
        }
        if (!lockpassword) {
            disabled = true;
        }
        return disabled;
    }

    const handleSubmit = () => {
        dispatch(lockUnlock({
            asset_id: assetId,
            userphone, usercmd: `${usercmd}${lockInput}`, lockpassword
        }))
        handleLockModalClose();
    }

    if (!regn) {
        return null;
    } else {
        return (
            <Dialog open={lockModalOpen} onClose={handleLockModalClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title"><b>Security: {regn}</b></DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {
                            summaryStatus === 'Malfunction' &&
                            <Typography variant="body1">
                                {`The Gps tracker signal is not strong enough to execute ${usercmd} command. Please wait till signal is stable.`}
                            </Typography>
                        }
                        {
                            speed > 20 && usercmd === 'lock' &&
                            <Typography variant="body1">
                                {`The vehicle is moving at ${speed} Km/h. It is not safe to lock a moving vehicle. Please wait till the speed comes down below 20 Km/h`}
                            </Typography>
                        }
                        {
                            lockValidate() &&
                            <Typography variant="body1"><b>
                                {`Ready to execute ${cmdName} command`}
                            </b></Typography>
                        }

                    </DialogContentText>
                    {
                        lockValidate() &&
                        <form>
                            <TextField
                                variant="standard"
                                autoFocus
                                label="Your Mobile Number"
                                type="number"
                                value={userphone}
                                onChange={(e) => setUserphone(e.target.value)}
                            />
                            <br />
                            <br />
                            <Typography variant="body1">Lock Password</Typography>
                            <TextField
                                variant="standard"
                                type="password"
                                value={lockpassword}
                                onChange={(e) => setLockpassword(e.target.value)}
                            />
                        </form>

                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleLockModalClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit} color="primary" disabled={formDisable()}>
                        Execute
                    </Button>
                </DialogActions>
            </Dialog>

        );
    }

}

export default LockUnlockModal;